/** French UI catalog. Keys are the English source strings. */
export const fr: Record<string, string> = {
  ", with {rate}% perfect passes": ", avec {rate} % de passes parfaites",
  "{avg} avg · {max} max": "{avg} moy. · {max} max",
  "{count} aces": "{count} aces",
  "{count} game serves": "{count} services en match",
  "{count} game serves across {games} game": "{count} services en match sur {games} match",
  "{count} game serves across {games} games": "{count} services en match sur {games} matchs",
  "{count} misses": "{count} fautes",
  "{count} playable": "{count} en jeu",
  "{count} shown": "{count} affichés",
  "{count} tracked serves": "{count} services suivis",
  "{count} tracked serves across {players} players. {rate}% landed in play.": "{count} services suivis chez {players} joueurs. {rate} % ont atterri en jeu.",
  "{name}'s outcomes": "Résultats de {name}",
  "{rate}% landed in play.": "{rate} % ont atterri en jeu.",
  "{rate}% miss rate": "{rate} % de fautes",
  "{start} – {end}": "{start} – {end}",
  "{value}% efficiency": "{value} % d'efficacité",
  "#{number}: {grade} average pass over {count} graded receptions.": "#{number} : passe moyenne de {grade} sur {count} réceptions notées.",
  "14 days": "14 jours",
  "30 days": "30 jours",
  "7 days": "7 jours",
  "8-week workload and efficiency": "Charge et efficacité sur 8 semaines",
  "Above-average miss risk": "Risque de faute au-dessus de la moyenne",
  "Account": "Compte",
  "Ace": "Ace",
  "Ace and miss rate · their pass average": "Taux d'aces et de fautes · leur moyenne de passe",
  "Ace rate": "Taux d'aces",
  "Ace rate vs miss rate": "Taux d'aces vs taux de faute",
  "Ace rate:": "Taux d'aces :",
  "Aces": "Aces",
  "Aces conceded": "Aces concédés",
  "across {count} game": "sur {count} match",
  "across {count} games": "sur {count} matchs",
  "across {count} players.": "chez {count} joueurs.",
  "Add player": "Ajouter un joueur",
  "Add the Supabase environment variables before resetting a password.": "Ajoutez les variables d'environnement Supabase avant de réinitialiser un mot de passe.",
  "Add VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY before signing in.": "Ajoutez VITE_SUPABASE_URL et VITE_SUPABASE_ANON_KEY avant de vous connecter.",
  "Add your first player from the Players view.": "Ajoutez votre premier joueur depuis la vue Joueurs.",
  "All games": "Tous les matchs",
  "All opponents": "Tous les adversaires",
  "All outcomes": "Tous les résultats",
  "All players": "Tous les joueurs",
  "All recorded sessions": "Toutes les séances enregistrées",
  "All seasons": "Toutes les saisons",
  "All serves": "Tous les services",
  "All time": "Toute la période",
  "Average on {min}–{max} · lower is better for us": "Moyenne sur {min}–{max} · plus bas est mieux pour nous",
  "average pass over {count} graded receptions.": "passe moyenne sur {count} réceptions notées.",
  "Average speed": "Vitesse moyenne",
  "Average speed · practice vs games · {metric}": "Vitesse moyenne · pratique vs matchs · {metric}",
  "Average speed {speed}": "Vitesse moyenne {speed}",
  "Average speed:": "Vitesse moyenne :",
  "avg ·": "moy. ·",
  "Avg speed": "Vitesse moy.",
  "Below-average miss risk": "Risque de faute sous la moyenne",
  "Best servers": "Meilleurs serveurs",
  "Birthday": "Anniversaire",
  "Cancel": "Annuler",
  "Clear": "Effacer",
  "Clear dates": "Effacer les dates",
  "Close editor": "Fermer l'éditeur",
  "Close navigation": "Fermer la navigation",
  "Close navigation overlay": "Fermer le menu de navigation",
  "Close player editor": "Fermer l'éditeur de joueur",
  "Close preview": "Fermer l'aperçu",
  "Close preview overlay": "Fermer la superposition d'aperçu",
  "Coach targets": "Cibles de l'entraîneur",
  "Coaches": "Entraîneurs",
  "Confirm password change": "Confirmer le changement de mot de passe",
  "Context matters": "Le contexte compte",
  "Continue with Apple": "Continuer avec Apple",
  "Continue with Google": "Continuer avec Google",
  "Could not generate report.": "Impossible de générer le rapport.",
  "Could not save player.": "Impossible d'enregistrer le joueur.",
  "Could not sign in.": "Impossible de se connecter.",
  "Could not start social sign-in.": "Impossible de démarrer la connexion sociale.",
  "Could not update password.": "Impossible de mettre à jour le mot de passe.",
  "Create your opponents and their games in the ServeBoost app (Analytics tab), then save serves to a game with the receiver's jersey number and pass grade. Breakdowns by team, game and season appear here.": "Créez vos adversaires et leurs matchs dans l'app ServeBoost (onglet Analytique), puis enregistrez les services d'un match avec le numéro du réceptionneur et la note de passe. Les bilans par équipe, match et saison apparaissent ici.",
  "CSV export": "Export CSV",
  "Dashboard": "Tableau de bord",
  "Dashed lines show player averages": "Les pointillés indiquent les moyennes des joueurs",
  "Date": "Date",
  "Date of birth": "Date de naissance",
  "Date presets": "Préréglages de date",
  "Delete": "Supprimer",
  "Delete report": "Supprimer le rapport",
  "Demo accounts cannot change passwords.": "Les comptes démo ne peuvent pas changer de mot de passe.",
  "Demo data": "Données démo",
  "Demo goals are read-only. Sign in to save custom targets.": "Les objectifs démo sont en lecture seule. Connectez-vous pour enregistrer des cibles.",
  "Demo roster is read-only. Sign in with a Supabase account to save changes.": "L'effectif démo est en lecture seule. Connectez-vous avec un compte Supabase pour enregistrer.",
  "Distribution": "Distribution",
  "Does pace hold up in games?": "Le rythme tient-il en match ?",
  "Download": "Télécharger",
  "Download report": "Télécharger le rapport",
  "Draft": "Brouillon",
  "Edit {name}": "Modifier {name}",
  "Edit player": "Modifier le joueur",
  "Editable fields": "Champs modifiables",
  "efficiency": "efficacité",
  "Efficiency": "Efficacité",
  "Eligibility": "Éligibilité",
  "Email": "E-mail",
  "English": "English",
  "Enter your email first.": "Entrez d'abord votre e-mail.",
  "Exit demo": "Quitter la démo",
  "Exports": "Exports",
  "First and last name are required.": "Le prénom et le nom sont obligatoires.",
  "First name": "Prénom",
  "First serve": "Premier service",
  "Float": "Float",
  "Float avg speed": "Vitesse moy. float",
  "Float eff.": "Eff. float",
  "Float efficiency": "Efficacité float",
  "Forgot password?": "Mot de passe oublié ?",
  "Français": "Français",
  "Game": "Match",
  "Game by game": "Match par match",
  "Game serving": "Service en match",
  "Games": "Matchs",
  "Generate": "Générer",
  "Generated {when}": "Généré le {when}",
  "Generated reports stay on this device. Use Generate or a template to create one.": "Les rapports générés restent sur cet appareil. Utilisez Générer ou un modèle pour en créer un.",
  "Generating...": "Génération…",
  "Goal progress": "Progression des objectifs",
  "Goals": "Objectifs",
  "Goals updated.": "Objectifs mis à jour.",
  "Height": "Taille",
  "HTML report": "Rapport HTML",
  "HTML report preview": "Aperçu du rapport HTML",
  "Hybrid": "Hybride",
  "Hybrid avg speed": "Vitesse moy. hybride",
  "Hybrid eff.": "Eff. hybride",
  "Hybrid efficiency": "Efficacité hybride",
  "Image URL": "URL de l'image",
  "In play": "En jeu",
  "in season {season}": "en saison {season}",
  "In-play rate": "Taux en jeu",
  "Individual speed, outcomes, trends": "Vitesse individuelle, résultats, tendances",
  "Language": "Langue",
  "Last name": "Nom",
  "Latest": "Plus récent",
  "Leaderboard": "Classement",
  "Leaderboard and period comparisons": "Classement et comparaisons de période",
  "Libero": "Libéro",
  "Loading dashboard": "Chargement du tableau de bord",
  "Loading ServeBoost": "Chargement de ServeBoost",
  "Local demo export": "Export démo local",
  "Lower pass average = tougher serve": "Moyenne de passe basse = service plus dur",
  "Match prep": "Préparation de match",
  "max": "max",
  "Max": "Max",
  "Max speed": "Vitesse max",
  "Median": "Médiane",
  "Median focus": "Focus médiane",
  "Middle Blocker": "Central",
  "Min": "Min",
  "Miss": "Faute",
  "miss rate": "taux de faute",
  "Miss rate": "Taux de faute",
  "Miss rate:": "Taux de faute :",
  "New password": "Nouveau mot de passe",
  "No data available": "Aucune donnée disponible",
  "No games yet": "Aucun match pour l'instant",
  "No player data": "Aucune donnée joueur",
  "No players yet": "Aucun joueur pour l'instant",
  "Number": "Numéro",
  "Number must be numeric.": "Le numéro doit être numérique.",
  "Open navigation": "Ouvrir la navigation",
  "Opening Apple…": "Ouverture d'Apple…",
  "Opening Google…": "Ouverture de Google…",
  "Opponent": "Adversaire",
  "Opposing receivers": "Réceptionneurs adverses",
  "Opposite": "Pointu",
  "or continue with email": "ou continuer avec l'e-mail",
  "Our servers": "Nos serveurs",
  "Outcome mix": "Répartition des résultats",
  "Outside Hitter": "Réceptionneur-attaquant",
  "Pace × ace rate · bubble = volume": "Rythme × taux d'aces · bulle = volume",
  "Pass": "Passe",
  "Pass average": "Moyenne de passe",
  "Pass quality by receiver": "Qualité de passe par réceptionneur",
  "Password": "Mot de passe",
  "Password updated. Use this password the next time you sign in.": "Mot de passe mis à jour. Utilisez-le à la prochaine connexion.",
  "PDF report": "Rapport PDF",
  "PDF report preview": "Aperçu du rapport PDF",
  "Perfect passes": "Passes parfaites",
  "playable": "en jeu",
  "Player": "Joueur",
  "Player performance map": "Carte de performance des joueurs",
  "Player review": "Revue joueur",
  "Player Summary": "Résumé des joueurs",
  "Players": "Joueurs",
  "Position": "Poste",
  "Positions": "Postes",
  "Practice": "Pratique",
  "Preseason baseline": "Base de présaison",
  "Preview report": "Aperçu du rapport",
  "Q1": "Q1",
  "Q3": "Q3",
  "Read-only demo": "Démo en lecture seule",
  "Ready": "Prêt",
  "Receiver": "Réceptionneur",
  "Reception by jersey number": "Réception par numéro",
  "Refine": "Affiner",
  "Report end date": "Date de fin du rapport",
  "Report preview": "Aperçu du rapport",
  "Report start date": "Date de début du rapport",
  "Reports": "Rapports",
  "Reset": "Réinitialiser",
  "Reset email sent.": "E-mail de réinitialisation envoyé.",
  "Results by game": "Résultats par match",
  "Risk and reward by serve": "Risque et récompense par service",
  "Risk review": "Revue des risques",
  "Roster": "Effectif",
  "Roster editor": "Éditeur d'effectif",
  "Save": "Enregistrer",
  "Save goals": "Enregistrer les objectifs",
  "Save player": "Enregistrer le joueur",
  "Saving...": "Enregistrement…",
  "Scope": "Portée",
  "Season": "Saison",
  "Season {season}": "Saison {season}",
  "Season packet": "Dossier de saison",
  "Select a row to focus on it": "Sélectionnez une ligne pour la cibler",
  "Select players": "Sélectionner des joueurs",
  "Selected": "Sélectionné",
  "Serve at": "Servez sur",
  "Serve at #{number}: {grade} average pass over {count} graded receptions.": "Servez sur #{number} : passe moyenne de {grade} sur {count} réceptions notées.",
  "Serve here": "Servez ici",
  "Serve mix, risk bands, target gaps": "Mix de services, bandes de risque, écarts aux objectifs",
  "Serve risk review": "Revue des risques au service",
  "Serve volume": "Volume de service",
  "Serve volume:": "Volume de service :",
  "ServeBoost": "ServeBoost",
  "ServeBoost Report": "Rapport ServeBoost",
  "serves": "services",
  "Serves": "Services",
  "Serves received": "Services reçus",
  "Serving in games": "Service en match",
  "Setter": "Passeur",
  "Settings": "Réglages",
  "Sign in": "Se connecter",
  "Sign in with a provider": "Se connecter avec un fournisseur",
  "Sign out": "Se déconnecter",
  "Signed in user": "Utilisateur connecté",
  "Speed faced": "Vitesse affrontée",
  "Speed metric": "Unité de vitesse",
  "Speed quantiles": "Quantiles de vitesse",
  "Spin": "Spin",
  "Spin avg speed": "Vitesse moy. spin",
  "Spin eff.": "Eff. spin",
  "Spin efficiency": "Efficacité spin",
  "Summary": "Résumé",
  "Targets vs current output": "Objectifs vs rendement actuel",
  "Team management": "Gestion d'équipe",
  "Team pulse": "Pouls de l'équipe",
  "Team serve analytics for coaches who need the signal quickly.": "Analytique de service pour les entraîneurs qui ont besoin du signal rapidement.",
  "Their pass average": "Moyenne de passe adverse",
  "Their reception averaged {grade} on a {min}–{max} scale": "Leur réception moyenne est de {grade} sur une échelle {min}–{max}",
  "This replaces the password you use to sign in.": "Cela remplace le mot de passe utilisé pour vous connecter.",
  "Top servers": "Meilleurs serveurs",
  "Tracked serves": "Services suivis",
  "Try demo data": "Essayer les données démo",
  "Unassigned": "Non assigné",
  "Update your password now? You will need the new password the next time you sign in.": "Mettre à jour votre mot de passe maintenant ? Vous aurez besoin du nouveau mot de passe à la prochaine connexion.",
  "Updating…": "Mise à jour…",
  "Upload photo": "Téléverser une photo",
  "Use template": "Utiliser le modèle",
  "Used across charts and summaries": "Utilisée dans les graphiques et résumés",
  "Volume + in-play rate · {metric}": "Volume + taux en jeu · {metric}",
  "vs {name}": "vs {name}",
  "vs {name} · {date}": "vs {name} · {date}",
  "vs {opponent}": "vs {opponent}",
  "vs {opponent} · {date}": "vs {opponent} · {date}",
  "Weakest passers first · scale {min}–{max}": "Passeurs les plus faibles d'abord · échelle {min}–{max}",
  "Weekly staff packet": "Dossier hebdo du staff",
  "Weight": "Poids",
  "What happens as speed rises?": "Que se passe-t-il quand la vitesse augmente ?",
  "with {rate}% perfect passes": "avec {rate} % de passes parfaites",
  "Workspace display language": "Langue d'affichage de l'espace de travail",
  "Yes, update password": "Oui, mettre à jour le mot de passe",
};
